// @flow
import { combineReducers } from 'redux';
import adminPanelReducer from './adminPanelReducer';
import NotificationsReducer from './NotificationsReducer';

const rootReducer = combineReducers({
    adminPanelReducer, NotificationsReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js